<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd"
					v-hasPermi="['system:role:add']">新增
				</el-button>
				<el-button size="small" type="success" icon="el-icon-download" v-hasPermi="['system:role:export']">导出
				</el-button>
			</el-col>
		</el-row>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
								v-model="quertInfo.searchTime" value-format="yyyy-MM-dd" style="width: 240px"
								start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-input size="mini" style="width: 240px" placeholder="请输入查询条件" clearable
								v-model="quertInfo.objMap.search" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" icon="el-icon-search" @click="onSearch"
								v-hasPermi="['system:role:query']">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
					:height="tableHeight()">
					<el-table-column prop="name" label="角色名称" width="250"></el-table-column>
					<el-table-column prop="code" label="角色编码" width="150"></el-table-column>
					<el-table-column prop="description" label="角色描述"></el-table-column>
					<el-table-column prop="status" label="状态" width="100" :formatter="formatStatus"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column label="操作" width="450">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)"
								v-hasPermi="['system:role:edit']">修改
							</el-button>
							<el-button type="text" icon="el-icon-circle-check" size="mini"
								@click="handleDataScope(scope.row)" v-hasPermi="['system:role:dataScope']">数据权限
							</el-button>
							<el-button type="text" icon="el-icon-delete" size="mini" v-if="scope.row.code != 'admin'"
								@click="handleDel(scope.row.id)" v-hasPermi="['system:role:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
						:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
			</el-card>
		</el-row>

		<el-dialog :visible.sync="openDialog" width="600px" :title="title">
			<el-form label-width="80px" ref="form" :model="form" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="角色名称" prop="name">
							<el-input v-model="form.name" placeholder="请输入角色名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="角色编码" prop="code">
							<el-input v-model="form.code" placeholder="请输入角色编码" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio :label="0">启用</el-radio>
								<el-radio :label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="菜单权限">
							<el-tree :data="optionPermiss" ref="menu" show-checkbox node-key="id">
							</el-tree>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="角色描述" prop="description">
							<el-input v-model="form.description" placeholder="请输入角色描述" />
						</el-form-item>
					</el-col>

				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm">确 定</el-button>
				<el-button @click="openDialog = false">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="openDataScope" width="500px" title="分配数据权限">
			<el-form label-width="100px" :model="form">
				<el-form-item label="角色名称">
					<el-input v-model="form.name" :disabled="true" />
				</el-form-item>
				<el-form-item label="角色编码">
					<el-input v-model="form.code" :disabled="true" />
				</el-form-item>
				<el-form-item label="数据权限范围" prop="dataScope">
					<el-select v-model="form.dataScope" placeholder="请选择">
						<el-option v-for="item in dataScopeOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数据权限" v-show="form.dataScope==2">
					<el-tree :data="optionDepts" show-checkbox node-key="id" ref="dept"></el-tree>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitDataScope">确 定</el-button>
				<el-button @click="openDataScope = false">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
	// 角色备注：系统暂时写死四种角色：
	// 角色编码：admin			角色名称：超级管理员
	// 角色编码：gys_role		角色名称：供应商角色
	// 角色编码：cgy_role		角色名称：采购员角色
	// 角色编码：gysWaitAudit	角色名称：供应商待审核角色	// 供应商只能通过门户供应商注册进来。
	import {
		roleList,
		addRole,
		editRole,
		delRole,
		rolePermissionByRId,
		roleDeptByRId,
		addDataScope,
	} from '@/api/system/role.js'
	import {
		treePermissionList
	} from '@/api/system/menu.js'
	import {
		deptTreeSelect,
	} from '@/api/system/dept.js'

	export default {
		name: "Role",

		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				openDialog: false,
				openDialog1: false,
				openDialog2: false,
				openDataScope: false,
				optionPermiss: [],
				optionDepts: [],
				count: 0,

				quertInfo: {
					searchTime: [],
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					objMap: {
						search: ''
					},
				},
				rules: {
					name: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入角色编码',
						trigger: 'blur'
					}],
				},
				// 数据权限范围选项
				dataScopeOptions: [{
						value: "1",
						label: "全部数据权限"
					},
					{
						value: "2",
						label: "自定数据权限"
					},
					{
						value: "3",
						label: "本部门数据权限"
					},
					{
						value: "4",
						label: "本部门及以下数据权限"
					},
					{
						value: "5",
						label: "仅本人数据权限"
					}
				],
			};
		},
		created() {
			this.getList();
			this.getTreePermisList();
			this.getDeptTreeSelect();
		},
		methods: {
			getDeptTreeSelect: function() {
				let _this = this;
				deptTreeSelect({}).then(({
					data
				}) => {
					_this.optionDepts = data.data;
				})
			},
			//权限树 数据
			getTreePermisList() {
				treePermissionList().then(({
					data
				}) => {
					this.optionPermiss = data.data;
				})
			},
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList()
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await roleList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				if (this.$refs.menu != undefined) {
					this.$refs.menu.setCheckedKeys([]);
				}
				this.form = {
					id: undefined,
					name: undefined,
					code: undefined,
					dataScope: undefined,
					description: undefined,
					status: 0,
					permissionIds: [],
					deptIds: []
				};
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			// 所有菜单节点数据
			getMenuAllCheckedKeys() {
				// 目前被选中的菜单节点
				let checkedKeys = this.$refs.menu.getHalfCheckedKeys();
				// 半选中的菜单节点
				let halfCheckedKeys = this.$refs.menu.getCheckedKeys();
				checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
				return checkedKeys;

			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if (_this.form.id != undefined) {
							_this.form.permissionIds = _this.getMenuAllCheckedKeys();
							editRole(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							_this.form.permissionIds = _this.getMenuAllCheckedKeys();
							addRole(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			handleAdd: function() {
				this.reset();
				this.title = "新增角色表";
				this.openDialog = true;
			},
			handleEdit: async function(row) {
				let _this = this;
				_this.reset();
				const {
					data: res
				} = await rolePermissionByRId({
					roleId: row.id
				});
				let permissIds = new Array();
				if (res.code == 0) {
					res.data.forEach(item => {
						permissIds.push(item.permissionId);
					})
				}
				_this.title = "修改角色表";
				_this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				_this.openDialog = true;
				//异步更新 防止tree 没有加载完 赋值报错
				_this.$nextTick(() => {
					_this.$refs.menu.setCheckedKeys(permissIds);
				});

			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delRole(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.open = false;
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			//数据权限按钮
			handleDataScope: async function(row) {
				let _this = this;
				_this.reset();
				const {
					data: res
				} = await roleDeptByRId({
					roleId: row.id
				});
				let deptIds = new Array();
				if (res.code == 0) {
					res.data.forEach(item => {
						deptIds.push(item.deptId);
					})
				}
				_this.form = JSON.parse(JSON.stringify(row));
				_this.openDataScope = true;
				//异步更新  赋值 角色綁定的部门
				_this.$nextTick(() => {
					_this.$refs.dept.setCheckedKeys(deptIds);
				});
			},
			/** 提交按钮（数据权限） */
			submitDataScope: function() {
				let _this = this;
				_this.form.deptIds = _this.getDeptAllCheckedKeys();
				addDataScope(_this.form).then(({
					data
				}) => {
					if (data.code === 0) {
						_this.$success(data.msg);
						_this.openDataScope = false;
						_this.getList();
					} else {
						_this.$fail(data.msg);
					}
				});
			},
			// 所有部门节点数据
			getDeptAllCheckedKeys() {
				// 目前被选中的部门节点
				let checkedKeys = this.$refs.dept.getHalfCheckedKeys();
				// 半选中的部门节点
				let halfCheckedKeys = this.$refs.dept.getCheckedKeys();
				checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
				return checkedKeys;
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},
		}
	};
</script>
<style scoped="scoped">
</style>
